import React from 'react'
import { MemberGlobalStyles } from 'spa/member/styles/GlobalStyles'
import SimpleFooter from 'spa/member/components/SimpleFooter/Index'
import { SimpleMemberLayoutProps } from './types'
import styled from 'styled-components'
import SimpleHeader from 'spa/member/components/SimpleHeader/Index'

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
`

export const StyledSimpleMemberLayout: React.FC = (props: SimpleMemberLayoutProps) => {
  return (
    <StyledLayout>
      <SimpleHeader />
      <MemberGlobalStyles />
      {props.children}
      <SimpleFooter stickyFooter={props.stickyFooter} />
    </StyledLayout>
  )
}
